import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import Link from 'shared/components/Link/Link';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import withSubscriptionSearch from 'shared/hocs/withSubscriptionSearch';
import SavedSearchItem from 'shared/components/SavedSearchItem/SavedSearchItem';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { withTranslate } from 'shared/hocs/withTranslate';
import onClickOutside from 'react-onclickoutside';
import s from './SearchSubInfoBlock.css';

class SearchSubInfoBlock extends React.PureComponent {
  static propTypes = {
    hideSavedSearch: PropTypes.func.isRequired,
    setSavedSearchToState: PropTypes.func.isRequired,
    savedSearch: PropTypes.shape(),
    verifySavedSearch: PropTypes.func.isRequired,
    saveSearch: PropTypes.func.isRequired,
    styles: PropTypes.string,
    //
    t: PropTypes.func.isRequired,
  };

  static defaultProps = {
    savedSearch: null,
    styles: '',
  };

  state = {
    isPopupOpened: false,
  };

  togglePopup = () => {
    this.setState(({ isPopupOpened }) => ({ isPopupOpened: !isPopupOpened }));
  };

  handleClickOutside = () => {
    if (this.props.savedSearch) {
      this.setState({ isPopupOpened: false });
    }
  };

  render() {
    const {
      styles,
      saveSearch,
      verifySavedSearch,
      savedSearch,
      setSavedSearchToState,
      hideSavedSearch,
      t,
    } = this.props;
    const { isPopupOpened } = this.state;

    if (verifySavedSearch() && !isPopupOpened) return null;

    return (
      <div className={cx(s.root, styles)}>
        <div className={s.image}>
          <div className={s.infoSection}>
            <div className={s.title}>
              {t('Узнавай о новых объявлениях')}
            </div>
            <Link
              onClick={() => {
                this.togglePopup();
                saveSearch();
              }}
              className={s.btn}
              data-lens-event="saveSearchClick"
            >
              {t('Подписаться на поиск')}
            </Link>
          </div>
        </div>

        <ReactCSSTransitionGroup
          transitionName="fadeUp"
          transitionEnterTimeout={100}
          transitionLeaveTimeout={100}
        >
          {savedSearch &&
            isPopupOpened &&
            <div className={s.popup}>
              <SavedSearchItem
                togglePopup={hideSavedSearch}
                searchItem={savedSearch}
                updateStateItemPeriod={setSavedSearchToState}
              />
            </div>}
        </ReactCSSTransitionGroup>
      </div>
    );
  }
}

export default withStyles(s)(
  withTranslate(withSubscriptionSearch(onClickOutside(SearchSubInfoBlock))),
);



// WEBPACK FOOTER //
// ./src/shared/components/SearchSubInfoBlock/SearchSubInfoBlock.js